import React from 'react';
import * as Yup from 'yup';
import {EMAIL_REGEX, PHONE_REGEX} from "../../../data/settings";

export const SaleOrderCustomerValidatorSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, 'tooShort')
        .max(50, 'tooLong')
        .required('required'),
    email: Yup.string()
        .nullable()
        .email("invalidEmail")
        .min(2, 'tooShort')
        .matches(EMAIL_REGEX, "invalidEmail"),
    phone: Yup.string()
        .nullable()
        .matches(PHONE_REGEX, 'invalidPhone')
});